import errors from './errors/index.js';
import translation from './translation/index.js';
const es = Object.freeze({
    translation,
    errors,
});
export default es;
